<template>
  <form @submit.prevent>
    <div>
      <label for="name">Name</label>
      <input
        v-model.trim="user.name"
        type="text"
        placeholder="Full Name"
        id="name"
      />
    </div>
    <div>
      <label for="title">Title</label>
      <input
        v-model.trim="user.title"
        type="text"
        placeholder="Title"
        id="title"
      />
    </div>
    <div>
      <label for="email2">Email</label>
      <input
        v-model.trim="user.email"
        type="text"
        placeholder="you@email.com"
        id="email2"
      />
    </div>
  </form>
</template>

<script>
import { bus } from "../main";
export default {
  props: {
    user: Object,
  },
  data() {
    return {
      createUserForm: {
        name: "",
        title: "",
        email: "",
      },
    };
  },
  methods: {},
};
</script>
